module.exports = __webpack_public_path__ + "img/plan-basic.f49190cb.svg";